<template>
	<div class="login-container d-flex">
		<el-col :xs="24" :sm="16" :md="12" :lg="9" :xl="7" class="m-auto">
			<div class="card">
				<div class="card-body">
					<h3 class="text-center">Informasi Kelulusan Siswa</h3>
					<h3 class="text-center">SMK PGRI 1 KEDIRI</h3>
					<hr />
					<el-form
						:model="loginForm"
						:rules="rules"
						@submit.prevent="login"
						ref="loginFormRef"
						size="large"
						label-width="auto"
						label-position="top"
						require-asterisk-position="right"
						:disabled="loading">
						<el-form-item label="Username" prop="username">
							<el-input v-model="loginForm.username" placeholder="Masukkan username" type="text" autocomplete="username" prefix-icon="UserFilled" autofocus />
						</el-form-item>
						<el-form-item label="Password" prop="password">
							<el-input v-model="loginForm.password" placeholder="Masukkan password" type="password" autocomplete="current-password" show-password prefix-icon="Lock" />
						</el-form-item>
						<hr />
						<el-form-item class="mb-0" size="default">
							<el-button type="primary" :loading="loading" native-type="submit" class="btn-login border-0 ms-auto px-4">Masuk</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-col>
	</div>
</template>

<script>
export default {
	name: "LoginForm",
	data() {
		return {
			loginForm: {
				username: "",
				password: "",
			},
			rules: {
				username: [{ required: true, message: "Silakan masukkan username", trigger: "change" }],
				password: [{ required: true, message: "Silakan masukkan password", trigger: "change" }],
			},
			loading: false,
		};
	},
	methods: {
		async login() {
			this.loading = true;
			try {
				const valid = await this.$refs.loginFormRef.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan username dan password");
				}

				const { data } = await this.axios.post("/kelulusan/login", this.loginForm);

				if (data) {
					this.$notify.success({
						title: "Berhasil",
						message: "Anda berhasil masuk untuk menagkses informasi kelulusan",
					});

					this.$store.dispatch("loginUser", data.data);
				}
			} catch (error) {
				if (error.response) {
					if (error.response.status === 401) {
						const usernameTemp = this.loginForm.username;
						this.$refs.loginFormRef.resetFields();
						this.loginForm.username = usernameTemp;
						this.$notify.error({
							title: "Gagal",
							message: error.response.data.message,
						});
						return;
					}

					console.error(error.response.data.errMessage);
					this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
					return;
				}

				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped>
.login-container {
	min-height: calc(100vh - 40px);
}
.btn-login {
	background: linear-gradient(135deg, #152746, #3763ac) !important;
}
.btn-login:hover {
	box-shadow: 0 0 8px 2px rgba(23, 58, 101, 0.5);
}
.btn-login:active {
	transform: scale(0.95);
	transition: 0.5s ease;
}
</style>
